import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Savings from './index';
import MobileSavings from './MobileSavings';

const ResponsiveSavings = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileSavings />}
      desktop={<Savings />}
    />
  );
};

export default ResponsiveSavings;